var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarScheduleLine = function SvgCalendarScheduleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 3.5v-1h1v1h3v-1h1v1h2a.5.5 0 0 1 .5.5v2.5h-1v-2h-1.5v1h-1v-1h-3v1h-1v-1H4v7h3v1H3.5A.5.5 0 0 1 3 12V4a.5.5 0 0 1 .5-.5zm5 4.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0M10 8.5v1.707l1.146 1.146.707-.707L11 9.793V8.5z"
  })));
};
export default SvgCalendarScheduleLine;